export const PERMISSIONS = Object.freeze({
  MANAGE_CONFIG: 'config.manage',
  MANAGE_USERS: 'users.manage',
  VIEW_AUDIT: 'audit.view',
  EDIT_PROMOTION: 'promotion.edit',
});

export const PERMISSION_OPTIONS = Object.freeze([
  {
    id: PERMISSIONS.MANAGE_CONFIG,
    label: '全局配置管理',
    description: '进入后台并维护站点、导航、公告、待办、主题和布局。',
  },
  {
    id: PERMISSIONS.EDIT_PROMOTION,
    label: '平台大促编辑',
    description: '在前台直接修改平台大促内容。',
  },
  {
    id: PERMISSIONS.MANAGE_USERS,
    label: '账号与权限管理',
    description: '创建、停用和编辑账号，并分配不高于自己的权限。',
  },
  {
    id: PERMISSIONS.VIEW_AUDIT,
    label: '操作记录查看',
    description: '查看账号、权限和全局配置的最近操作记录。',
  },
]);

const VALID_PERMISSIONS = new Set(PERMISSION_OPTIONS.map((permission) => permission.id));

export function normalizePermissions(value) {
  if (!Array.isArray(value)) return [];
  return [...new Set(value.map((permission) => String(permission || '').trim()).filter((permission) => VALID_PERMISSIONS.has(permission)))];
}

export function effectivePermissions(user) {
  if (!user) return [];
  if (user.role === 'admin') return PERMISSION_OPTIONS.map((permission) => permission.id);
  const permissions = normalizePermissions(user.permissions);
  if (user.canEditPromotion === true && !permissions.includes(PERMISSIONS.EDIT_PROMOTION)) {
    permissions.push(PERMISSIONS.EDIT_PROMOTION);
  }
  return permissions;
}

export function hasPermission(user, permission) {
  return effectivePermissions(user).includes(permission);
}

export function canAccessAdmin(user) {
  return [PERMISSIONS.MANAGE_CONFIG, PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_AUDIT]
    .some((permission) => hasPermission(user, permission));
}

export function permissionsFromInput(input = {}, fallback = []) {
  const permissions = input.permissions == null ? normalizePermissions(fallback) : normalizePermissions(input.permissions);
  if (input.canEditPromotion === true && !permissions.includes(PERMISSIONS.EDIT_PROMOTION)) {
    permissions.push(PERMISSIONS.EDIT_PROMOTION);
  }
  if (input.canEditPromotion === false) {
    return permissions.filter((permission) => permission !== PERMISSIONS.EDIT_PROMOTION);
  }
  return permissions;
}
